import { SUGGESTED_FILTERS_2ROW_EXPERIMENT } from '~/constants/srp/suggestedFilters2Row';
import { useIsMobile } from '~/context/common/DeviceContext';
import useIsInExperiment from '~/hooks/common/experiments/useIsInExperiment';

export default function useIsInSuggestedFilters2RowExperiment() {
  const isMobile = useIsMobile();
  const isTreatment = useIsInExperiment(
    SUGGESTED_FILTERS_2ROW_EXPERIMENT,
    'treatment'
  );

  return isMobile && isTreatment;
}
